var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUserOutlineFilled = function SvgUserOutlineFilled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M15.121 13.726a3.65 3.65 0 0 1 1.576-.085h.001c2.26.378 3.702 1.805 3.702 3.247v3.49c0 .069-.038.185-.206.308a1.26 1.26 0 0 1-.734.214H4.54c-.31 0-.568-.093-.734-.214-.168-.123-.206-.24-.206-.307v-3.491c0-1.442 1.441-2.87 3.702-3.247a3.65 3.65 0 0 1 1.577.085c2.079.59 4.163.59 6.242 0ZM12 3.1c2.296 0 4.161 1.87 4.161 4.181S14.296 11.463 12 11.463 7.839 9.593 7.839 7.28C7.839 4.97 9.704 3.1 12 3.1Z",
    opacity: 0.8
  })));
};
export { SvgUserOutlineFilled as ReactComponent };
export default __webpack_public_path__ + "static/media/userOutlineFilled.b3416b9fa1edc5008fd93e060db5217a.svg";